import { TemplateType } from "@xapp/ovai-lib";
import { ON_DEMAND_TEMPLATE, RADIO_TEMPLATE } from "constants/templates";

export function getAvailableTemplateTypes(admin?: boolean): (TemplateType | string)[] {
    if (__ACCOUNT__ === "studio") {
        return ["OC_STUDIO_STARTER_TEMPLATE", "CUSTOM"];
    } else if (admin) {
        // All of them
        return [RADIO_TEMPLATE, ON_DEMAND_TEMPLATE, "OC_STUDIO_STARTER_TEMPLATE", "CUSTOM"];
    } else if (__ENV__ === "staging" || __ENV__ === "development") {
        // All of them
        return [RADIO_TEMPLATE, ON_DEMAND_TEMPLATE, "OC_STUDIO_STARTER_TEMPLATE", "CUSTOM"];
    } else {
        return [RADIO_TEMPLATE, ON_DEMAND_TEMPLATE, "CUSTOM"];
    }
}